import { Role } from './role';
import {Station} from "../../models/Station";

export class User {
  id: number;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  avatar: string;
  role: Role;
  token?: string;
  stations?: Station[];
}
